//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */
const ajax = require("../../util/ajax");
const Lerc = require("lerc");
const RasterTileSource = require("../../source/raster_tile_source");


class Lerc3DTileSource extends RasterTileSource {
    constructor(id, options, dispatcher, eventedParent) {
        super(id, options, dispatcher, eventedParent);
        this.lercVersion = options.lercVersion || 1;
        this.headers = options.headers || [];
    }

    loadTile(tile, callback) {
        let url = this.map._requestManager.normalizeTileURL(
            tile.tileID.canonical.url(this.tiles, this.scheme),
            this.url,
            this.tileSize
        );
        if (this.lercVersion === 1) {
            url = this.setLercUrl(tile, "http://101.201.77.235:8080/");
        }

        let pixelObj;

        const requestParameters = {
            url: url,
            headers: this.headers,
        };

        tile.request = ajax.getArrayBuffer(requestParameters, done.bind(this));

        function done(err, lerc) {
            delete tile.request;

            if (tile.aborted) {
                this.state = "unloaded";
                return callback(null);
            }

            if (err) {
                this.state = "errored";
                return callback(err);
            }

            pixelObj = Lerc.decode(lerc.data);


            if (!pixelObj) {
                console.error("lerc decode failed!");
            }

            tile.pixelObj = pixelObj;

            tile.state = "loaded";

            callback(null);
        }
    }

    setLercUrl(tile, url) {
        let z = tile.tileID.canonical.z,
            y = tile.tileID.canonical.y.toString(16),
            x = tile.tileID.canonical.x.toString(16);

        if (z < 10) z = `0${z}`;
        const rLength = y.length; // row è¡å·

        if (rLength < 8) {
            for (let i = 0; i < 8 - rLength; i++) {
                y = `0${y}`;
            }
        }
        const r = `R${y}`;

        const cLength = x.length;

        if (cLength < 8) {
            for (let i = 0; i < 8 - cLength; i++) {
                x = `0${x}`;
            }
        }

        const c = `C${x}`; // æ ¹

        const sUrl = `${url}L${z}/${r}/${c}.lerc`;
        return sUrl;
    }
}

module.exports = Lerc3DTileSource;
